import { Component, Injector, OnInit, OnDestroy, ViewEncapsulation, NgZone, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { NotificationServiceProxy, UserNotification, UserNotificationState } from '@shared/service-proxies/service-proxies';
import { IFormattedUserNotification, UserNotificationHelper } from './UserNotificationHelper';
import { Router } from '@angular/router';
import { DateTime } from 'luxon';
import { AppRoutes } from '@app/shared/routes/app-routes';
import * as xlsx from "xlsx-js-style";
import { AppConsts } from '@shared/AppConsts';
import { finalize } from 'rxjs/operators';
import { SignalRService } from '../../services/signalr.service';
const FileSaver = require("file-saver");
@Component({
    standalone: false,
    templateUrl: "./header-notifications.component.html",
    styleUrls: ["./header-notifications.component.css"],
    selector: "header-notifications",
    encapsulation: ViewEncapsulation.None,
    styles: [
        `
            .topbar-item:hover span {
                transform: translateY(-3px);
                transition: all 0.3s ease-in-out;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderNotificationsComponent extends AppComponentBase implements OnInit, OnDestroy {
    notifications: IFormattedUserNotification[] = [];
    unreadNotificationCount = 0;
    @Input()
    isDropup = false;
    @Input()
    customStyle = "btn btn-icon btn-dropdown btn-clean btn-md mr-1";
    notification_section;
    readStateFilter = "ALL";
    notificationStatus: boolean = false;
    skipCount = 0;
    takeCount = 25;
    defaultTakeCount = 25;
    dataLoading = false;
    allNotificationsAppSource: UserNotification[] = [];
    scrolled: boolean;
    startDate: DateTime;
    endDate: DateTime;
    private readonly userImportedFromExcelHandler = (data) => this.createcallBackFunctionsforSignalR(data);
    private readonly taskImportedFromExcelHandler = (data) => this.createcallBackFunctionsforSignalR(data);
    private readonly notificationReceivedHandler = (userNotification) => {
        this._zone.run(() => {
            this._userNotificationHelper.show(userNotification);
            this.loadNotifications();
        });
    };
    private readonly notificationsRefreshHandler = () => {
        this._zone.run(() => {
            this.loadNotifications();
        });
    };
    private readonly notificationReadHandler = (userNotificationId) => {
        this._zone.run(() => {
            for (let i = 0; i < this.notifications.length; i++) {
                if (this.notifications[i].userNotificationId === userNotificationId) {
                    this.notifications[i].state = "READ";
                    this.notifications[i].isUnread = false;
                }
            }
            this.unreadNotificationCount = this.unreadNotificationCount == 0 ? this.unreadNotificationCount : this.unreadNotificationCount - 1;
            this.cdRef.markForCheck();
        });
    };
    constructor(injector: Injector, private _notificationServiceProxy: NotificationServiceProxy, private _userNotificationHelper: UserNotificationHelper, public _zone: NgZone, private router: Router, 
    // SignalR ***
    private cdRef: ChangeDetectorRef, private _signalRService: SignalRService) {
        super(injector);
    }
    ngOnInit(): void {
        // SignalR ***
        abp.event.on("SignalRUserWiseUserImportedFromExcel", this.userImportedFromExcelHandler);
        abp.event.on("SignalRUserWiseTaskImportedFromExcel", this.taskImportedFromExcelHandler);
        // SignalR ***
        if (!AppConsts.initialLoadHeaderNotificationComponent) {
            AppConsts.initialLoadHeaderNotificationComponent = true;
            this.loadNotifications(true);
        }
        else {
            this.unreadNotificationCount = AppConsts.unreadNotificationCount;
        }
        this.registerToEvents();
    }
    stopPropogation(event: Event) {
        event.stopPropagation();
    }
    public createcallBackFunctionsforSignalR(objValues) {
        if (!objValues)
            return;
        if (objValues.userId == abp.session.userId && abp.session.tenantId == objValues.tenantId) {
            if (objValues.message == "Import Failed") {
                this.notify.error("Import Failed");
            }
            else if (objValues.message == "Empty File") {
                this.notify.error("Import Failed Becuase of Empty File");
            }
            else if (objValues.message == "Invalid File") {
                this.notify.error("Import Failed Becuase of Invalid File");
            }
            else {
                this.notify.success(this.l("ImportCompleted"));
            }
        }
        this.loadNotifications();
    }
    loadNotifications(next = false): void {
        this.dataLoading = true;
        if (!next) {
            this.skipCount = 0;
            this.takeCount = this.defaultTakeCount;
            this.allNotificationsAppSource = [];
        }
        this._notificationServiceProxy
            .getUserNotifications(this.readStateFilter === "ALL" ? undefined : UserNotificationState.Unread, this.startDate, this.endDate, this.takeCount, this.skipCount)
            .pipe(finalize(() => {
            this.dataLoading = false;
            this.cdRef.markForCheck();
        }))
            .subscribe((result) => {
            this.unreadNotificationCount = result.unreadCount;
            AppConsts.unreadNotificationCount = result.unreadCount;
            if (next) {
                this.skipCount += this.defaultTakeCount;
                this.takeCount += this.defaultTakeCount;
                this.scrolled = false;
            }
            else {
                this.allNotificationsAppSource = [];
            }
            for (let notification of result?.items) {
                if (!this.allNotificationsAppSource?.some(item => item.id === notification.id)) {
                    this.allNotificationsAppSource.push(notification);
                }
            }
            let formattedNotifications = this.allNotificationsAppSource.map((r) => this._userNotificationHelper?.format(<any>r, false));
            this.notifications = formattedNotifications;
            this.markForCheck();
        });
    }
    notificationScroll(e) {
        if (e.target.scrollHeight < e.target.scrollTop + e.target.offsetHeight) {
            if (!this.scrolled) {
                this.scrolled = true;
                this.loadNotifications(true);
            }
        }
    }
    isTodaysNotifications(notification: any): boolean {
        let notificationDate = this.getLocalJsDate(notification.creationTime);
        let currDate = new Date();
        notificationDate.setHours(0, 0, 0, 0);
        currDate.setHours(0, 0, 0, 0);
        return notificationDate.toLocaleDateString() === currDate.toLocaleDateString();
    }
    isFirstEarlierNotification(notification: any) {
        let earlierNotifications = this.getEarlierNotifications(this.notifications);
        return earlierNotifications[0].userNotificationId === notification.userNotificationId;
    }
    registerToEvents() {
        abp.event.on("abp.notifications.received", this.notificationReceivedHandler);
        abp.event.on("app.notifications.refresh", this.notificationsRefreshHandler);
        abp.event.on("app.notifications.read", this.notificationReadHandler);
    }
    ngOnDestroy(): void {
        abp.event.off("SignalRUserWiseUserImportedFromExcel", this.userImportedFromExcelHandler);
        abp.event.off("SignalRUserWiseTaskImportedFromExcel", this.taskImportedFromExcelHandler);
        abp.event.off("abp.notifications.received", this.notificationReceivedHandler);
        abp.event.off("app.notifications.refresh", this.notificationsRefreshHandler);
        abp.event.off("app.notifications.read", this.notificationReadHandler);
    }
    getTodaysNotifications(notifications: any[]) {
        if (!notifications)
            return [];
        return notifications.filter((r) => {
            let notificationDate = this.getLocalJsDate(r.creationTime);
            let currDate = new Date();
            notificationDate.setHours(0, 0, 0, 0);
            currDate.setHours(0, 0, 0, 0);
            return notificationDate.toLocaleDateString() === currDate.toLocaleDateString();
        });
    }
    getEarlierNotifications(notifications: any[]) {
        //
        if (!notifications)
            return [];
        return notifications.filter((r) => {
            let notificationDate = this.getLocalJsDate(r.creationTime);
            let currDate = new Date();
            notificationDate.setHours(0, 0, 0, 0);
            currDate.setHours(0, 0, 0, 0);
            return notificationDate.toLocaleDateString() !== currDate.toLocaleDateString();
        });
    }
    getNotificationText(notification: IFormattedUserNotification) {
        return notification.text.split("[")[0];
    }
    redirectLinkForTimesheet(notification: IFormattedUserNotification) {
        let arr: string[] = notification.text.split("{");
        return arr.length > 1;
    }
    goToTimesheet(notification: IFormattedUserNotification) {
        let arr: string[] = notification.text.split("{");
        if (arr.length > 1) {
            arr[1] = arr[1].slice(0, arr[1].length - 1);
            let mainRoute = arr[1].split("?")[0];
            let id = arr[1].split("?")[1].split("&")[0].split("=")[1];
            let isMyTimesheet = arr[1].split("?")[1].split("&")[1].split("=")[1];
            this.router.navigate([mainRoute], { queryParams: { id: parseInt(id), myTimesheet: isMyTimesheet } });
        }
    }
    getNotificationImage(notification: IFormattedUserNotification) {
        if (notification.text.split("[").length <= 1)
            return null;
        if (notification.text.split("[")[1].split(",").length <= 1)
            return null;
        return notification.text.split("[")[1].split(",")[1].split("]")[0];
    }
    getNotificationModule(notification: IFormattedUserNotification) {
        return this.getNotificationModuleString(notification.text);
    }
    getNotificationModuleString(text) {
        let textArray = text.split(/[[\],{}]/).filter(Boolean);
        if (textArray.includes("Time Tracking"))
            return "Time Tracking";
        if (textArray.includes("Time And Attendance"))
            return "Time And Attendance";
        if (textArray.includes("Manage Users"))
            return "Manage Users";
        if (textArray.includes("Leaves") || textArray.includes("Time Off"))
            return "Leaves";
        if (textArray.includes("Timesheet"))
            return "Timesheet";
        if (textArray.includes("Project"))
            return "Project";
        return null;
    }
    setAllNotificationsAsRead(): void {
        this._userNotificationHelper.setAllAsRead();
        this.notifications = this.notifications.map((n) => {
            n.state = 'READ';
            return n;
        });
        this.unreadNotificationCount = 0;
        this.notificationStatus = true;
    }
    openNotificationSettingsModal(): void {
        this._userNotificationHelper.openSettingsModal();
    }
    setNotificationAsRead(userNotification: IFormattedUserNotification): void {
        if (userNotification.state !== "READ") {
            this.notificationStatus = false;
            this._userNotificationHelper.setAsRead(userNotification.userNotificationId);
        }
    }
    async gotoUrl(url: string) {
        if (url) {
            if (url.includes("InvalidUserFile")) {
                var t = await this.toDataURL(url);
                this.exportUsersListToExcel(t);
            }
            else if (url.includes("InvalidTaskFile")) {
                var t = await this.toDataURL(url);
                this.exportTaskListToExcel(t);
            }
            else if (url.includes("InvalidHolidayFile")) {
                var t = await this.toDataURL(url);
                this.exportHolidayListToExcel(t);
            }
            else {
                location.href = url;
            }
        }
    }
    toDataURL(url) {
        return fetch(url).then((response) => {
            return response.json();
        });
    }
    exportUsersListToExcel(userRecords) {
        const workbook: xlsx.WorkBook = xlsx.utils.book_new();
        const worksheet: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
        xlsx.utils.sheet_add_aoa(worksheet, [['First Name', 'Last Name', 'Email Address', 'Employee Id', 'Role', 'Organization Unit', 'Manager Email', 'Mobile Number', 'Address', 'City', 'ZipCode', 'State', 'Country', 'Reporting Location', 'Login Access', "Leaves/Month", "DateOfBirth(MM/dd/YYYY)", 'Exception']], {
            origin: "A1",
        });
        let data = userRecords.map((x) => {
            let arr = [x.FirstName, x.LastName, x.EmailAddress, x.employeeId, x.Role, x.OrganizationUnit, x.ManagerEmail, x.MobileNumber, x.Address, x.City, x.ZipCode, x.State, x.Country, x.ReportingLocation, x.LoginAccess, x.LeavesPerMonth, x.DateOfBirth, x.Exception];
            return arr;
        });
        xlsx.utils.sheet_add_aoa(worksheet, data, { origin: "A2" });
        worksheet["!cols"] = [
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 30 },
            { width: 30 },
            { width: 30 },
            { width: 20 },
            { width: 80 },
        ];
        for (let i in worksheet) {
            if (typeof worksheet[i] != "object")
                continue;
            let cell = xlsx.utils.decode_cell(i);
            worksheet[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            };
            if (cell.r == 0) {
                worksheet[i].s.font.bold = true;
                worksheet[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "DDDDDD" },
                };
            }
        }
        xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        const excelBuffer: any = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });
        let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data2: Blob = new Blob([excelBuffer], {
            type: EXCEL_TYPE,
        });
        FileSaver.saveAs(data2, "Invalid Users List" + EXCEL_EXTENSION);
    }
    exportTaskListToExcel(TaskList) {
        const workbook: xlsx.WorkBook = xlsx.utils.book_new();
        const worksheet: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
        xlsx.utils.sheet_add_aoa(worksheet, [['Project Name', 'Task Name',
                'Assigned To', 'Priority', 'Severity', 'Activity Name', 'Original Estimate', 'Billability Status', 'Refuse Reason']], {
            origin: "A1",
        });
        let data = TaskList.map((x) => {
            let arr = [x.ProjectName, x.TaskName, x.AssignedTo, x.Prority, x.Severity, x.ActivityName, x.OriginalEstimate, x.BillabilityStatus, x.Exception];
            return arr;
        });
        xlsx.utils.sheet_add_aoa(worksheet, data, { origin: "A2" });
        worksheet["!cols"] = [
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
        ];
        for (let i in worksheet) {
            if (typeof worksheet[i] != "object")
                continue;
            let cell = xlsx.utils.decode_cell(i);
            worksheet[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            };
            if (cell.r == 0) {
                worksheet[i].s.font.bold = true;
                worksheet[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "DDDDDD" },
                };
            }
        }
        xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        const excelBuffer: any = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });
        let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data2: Blob = new Blob([excelBuffer], {
            type: EXCEL_TYPE,
        });
        FileSaver.saveAs(data2, "Invalid Task List" + EXCEL_EXTENSION);
    }
    exportHolidayListToExcel(TaskList) {
        const workbook: xlsx.WorkBook = xlsx.utils.book_new();
        const worksheet: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
        xlsx.utils.sheet_add_aoa(worksheet, [['Holiday Date(dd/MM/YYYY)', 'Holiday Name',
                'Location', 'Description', 'Refuse Reason']], {
            origin: "A1",
        });
        let data = TaskList.map((x) => {
            let arr = [];
            if (x.Exception.includes("date")) {
                arr = [x.holiDayDate, x.name, x.Location, x.Description, x.Exception];
            }
            else {
                arr = [Math.round(parseFloat(x.holidayDate)), x.name, x.Location, x.Description, x.Exception];
            }
            return arr;
        });
        xlsx.utils.sheet_add_aoa(worksheet, data, { origin: "A2" });
        worksheet["!cols"] = [
            { width: 40 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 80 },
        ];
        for (let i in worksheet) {
            if (typeof worksheet[i] != "object")
                continue;
            let cell = xlsx.utils.decode_cell(i);
            worksheet[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            };
            if (cell.r == 0) {
                worksheet[i].s.font.bold = true;
                worksheet[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "DDDDDD" },
                };
            }
            else if (cell.c == 0) {
                worksheet[i].z = "dd/mm/yyyy";
            }
        }
        xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        const excelBuffer: any = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });
        let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data2: Blob = new Blob([excelBuffer], {
            type: EXCEL_TYPE,
        });
        FileSaver.saveAs(data2, "Invalid Holiday List" + EXCEL_EXTENSION);
    }
    // get local js date from a UTC datetime object
    getLocalJsDate(date: DateTime): Date {
        let jsDate = new Date(`${date.year}-${date.month < 10 ? "0" + date.month : date.month}-${date.day < 10 ? "0" + date.day : date.day}T${date.hour < 10 ? "0" + date.hour : date.hour}:${date.minute < 10 ? "0" + date.minute : date.minute}:${date.second < 10 ? "0" + date.second : date.second}`);
        return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);
    }
    goToProject(notification: IFormattedUserNotification) {
        let arr: string[] = notification.text.split("{");
        if (arr.length > 1) {
            arr[1] = arr[1].slice(0, arr[1].length - 1);
            let mainRoute = arr[1].split("?")[0];
            this.router.navigate([mainRoute]);
        }
    }
    goToManageUser(notification: IFormattedUserNotification) {
        let arr: string[] = notification.text.split("{");
        if (arr.length > 1) {
            arr[1] = arr[1].slice(0, arr[1].length - 1);
            let mainRoute = arr[1].split("?")[0];
            this.router.navigate([mainRoute]);
        }
    }
    goToTimeOff(notification: IFormattedUserNotification) {
        let arr: string[] = notification.text.split("{");
        if (arr.length > 1) {
            arr[1] = arr[1].slice(0, arr[1].length - 1);
            let mainRoute = arr[1].split("?")[0];
            this.router.navigate([mainRoute]);
        }
    }
    goToTimeTracking(notification: IFormattedUserNotification) {
        let arr: string[] = notification.text.split("{");
        if (arr.length > 1) {
            arr[1] = arr[1].slice(0, arr[1].length - 1);
            let mainRoute = arr[1].split("?")[0];
            this.router.navigate([mainRoute]);
        }
    }
    goToModule(notification) {
        this.setNotificationAsRead(notification);
        var notification_module = this.getNotificationModuleString(notification.text);
        if (notification_module == "Timesheet") {
            var timesheetIdstr = notification.text?.split('{')[1]?.split('?')[1]?.split('=')[1]?.split('&')[0];
            let timesheetId = timesheetIdstr ? parseInt(timesheetIdstr) : undefined;
            if (timesheetId)
                this.router.navigate([AppRoutes.timesheet], { state: { timesheetId: timesheetId } });
            if (!timesheetId)
                this.router.navigate([AppRoutes.timesheet]);
        }
        else if (notification_module == 'Leaves') {
            var timeOffIdstr: string = notification.text?.split('{')[1]?.split('?')[1]?.split('=')[1]?.split('}')[0];
            let timeOffId = timeOffIdstr ? parseInt(timeOffIdstr) : undefined;
            if (timeOffId) {
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                    this.router.navigate([AppRoutes.leaves], { state: { timeOffId: timeOffId } });
                });
            }
            if (!timeOffId)
                this.router.navigate([AppRoutes.leaves]);
        }
        else if (notification_module == 'Time Tracking') {
            let taskId = notification.text?.split('{')[1]?.split('?')[1]?.split('=')[1]?.split('}')[0];
            if (taskId)
                taskId = parseInt(taskId);
            this.router.navigate([AppRoutes.timeTracking], { state: { taskId: taskId } });
        }
        else if (notification_module == 'Project') {
            try {
                var project_string = notification.text.split('}{')[1];
                var project_id_string = project_string.split('=')[1];
                var project_id = project_id_string.split('}')[0];
                this.router.navigate([AppRoutes.projectsDetails], { state: { ProjectId: project_id, option: 1 }, queryParams: { ProjectId: project_id, option: 1 } });
            }
            catch {
                this.router.navigate([AppRoutes.projects]);
            }
        }
        else if (notification_module == "Manage Users") {
            this.router.navigate([AppRoutes.admin.users]);
        }
        else if (notification_module == "Time And Attendance") {
            let taaDate = notification.text?.split('{')[1]?.split('?')[1]?.split('=')[1]?.split('}')[0];
            if (taaDate) {
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                    this.router.navigate([AppRoutes.activitiesTimeAndAttendance + '?todayDate=' + taaDate]);
                });
            }
            else {
                this.router.navigate([AppRoutes.activitiesTimeAndAttendance]);
            }
        }
    }
    onPSidebarShow() {
        this.notifications = [];
        this.skipCount = 0;
        this.loadNotifications();
    }
    onPSidebarHide() {
        this.notifications = [];
        this.skipCount = 0;
    }
    scrollEvent(e) {
        if (e.target.scrollHeight < e.target.scrollTop + e.target.offsetHeight) {
            this.loadNotifications(true);
        }
    }
}
